import { QuestionAnswerResult } from "src/app/_models/QuestionResults";
import { SkillsCheckQandAState } from "./skills-check-q-and-a.state";

export function getState(state: SkillsCheckQandAState, action: {state: QuestionAnswerResult, courseId: number}): QuestionAnswerResult[]{
	const { courseId } = action;
	const { questionAnswerState } = state;

	if(state.course !== courseId || questionAnswerState.length === 0){
		return [action.state];
	}
	
	if (questionAnswerState.length > 0 && action.state) {
		return addQuestionAnswerState(state, action.state);
	}

	return questionAnswerState;
}

export function addQuestionAnswerState(	
	state: SkillsCheckQandAState, actionState: QuestionAnswerResult
): QuestionAnswerResult[]{

	if(!state.questionAnswerState.find(i => i.learnerTargetOutcomeId == actionState.learnerTargetOutcomeId))
		return [...state.questionAnswerState, actionState];
	
	return state.questionAnswerState;
}